import {writable} from "svelte/store";
export const  videoPlaybackStore = writable(0)
